import React from 'react';
import { Gift, Sword, ShieldCheck, Zap, Calculator, FlaskConical, Rocket } from 'lucide-react';
const bonuses = [{
  title: 'Tácticas para atacantes',
  desc: 'Desmarques, definición, presión alta, movimientos dentro del área y jugadas para generar peligro.',
  icon: Sword,
  image: 'https://cdn.magicpatterns.com/uploads/9wx2NqidLxHnXNTxeeLg2y/image.png'
}, {
  title: 'Tácticas para defensoras',
  desc: 'Marca, anticipación, cierres, salida limpia, duelos 1 vs 1 y lectura defensiva.',
  icon: ShieldCheck,
  image: 'https://cdn.magicpatterns.com/uploads/trqXPEyVV314NaArpb728k/image.png'
}, {
  title: 'Velocidad y Reacción PRO',
  desc: 'Drills listos para acelerar, frenar, cambiar de dirección y llegar antes a cada jugada.',
  icon: Zap,
  image: 'https://cdn.magicpatterns.com/uploads/sGm68yP3Lz2d9jP2JaEjb8/image.png'
}, {
  title: 'Calculadora de proteínas e hidratación',
  desc: 'Para ordenar tu energía, recuperación y rendimiento fuera de la cancha.',
  icon: Calculator,
  image: 'https://cdn.magicpatterns.com/uploads/3kitbVXfpHLFKQXPoRDyWz/image.png'
}, {
  title: 'Guía de suplementos con respaldo científico',
  desc: 'Qué sirve, qué no y cómo usarlo sin perder plata en cosas innecesarias.',
  icon: FlaskConical,
  image: 'https://cdn.magicpatterns.com/uploads/4bFuVoadmcZobyW1Jinqq3/image.png'
}, {
  title: 'Las bases de la velocidad en hockey',
  desc: '24 drills + circuitos para desarrollar tu velocidad al máximo.',
  icon: Rocket,
  image: 'https://cdn.magicpatterns.com/uploads/7RL48B4XpuHzeuW3xMtK8J/image.png'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#223322]" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <div className="text-center mb-14" data-id="element-15">
          <div className="inline-flex items-center gap-2 bg-[#2e7d32]/20 border border-[#c8e6c9]/30 text-[#c8e6c9] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-16">
            <Gift className="w-3.5 h-3.5" data-id="element-17" /> Incluido sin costo
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#c8e6c9]" data-id="element-18">
            Bonos pensados para mejorar más rápido
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-19">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <div key={index} onClick={scrollToPurchase} className="bg-[#1a2e1a] rounded-2xl border border-[#2e7d32]/40 relative overflow-hidden group hover:border-[#4caf50] transition-all cursor-pointer flex flex-col" data-id="element-20">
                <div className="absolute top-3 right-3 z-10 bg-[#2e7d32] text-[#faf5e8] text-[10px] font-bold px-2.5 py-1 rounded-md uppercase tracking-wider shadow-lg" data-id="element-21">
                  Gratis
                </div>

                {bonus.image ? <div className="relative w-full h-40 overflow-hidden bg-[#0f1a0f]" data-id="element-22">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-23" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1a2e1a] via-transparent to-transparent" data-id="element-24" />
                  </div> : <div className="relative w-full h-40 bg-gradient-to-br from-[#2e7d32]/20 to-[#142014] flex items-center justify-center overflow-hidden" data-id="element-25">
                    <Icon className="w-20 h-20 text-[#c8e6c9]/40 group-hover:scale-110 transition-transform duration-500" data-id="element-26" />
                  </div>}

                <div className="p-6 flex flex-col flex-1" data-id="element-27">
                  <div className="flex items-center gap-2 mb-3" data-id="element-28">
                    <div className="w-8 h-8 bg-[#2e7d32]/15 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-29">
                      <Icon className="w-4 h-4 text-[#4caf50]" data-id="element-30" />
                    </div>
                    <p className="text-xs text-[#4caf50] font-bold uppercase tracking-wider" data-id="element-31">
                      Bono {index + 1}
                    </p>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-[#faf5e8] leading-snug mb-2" data-id="element-32">
                    {bonus.title}
                  </h3>
                  <p className="text-[#a8c5a8] text-sm leading-relaxed" data-id="element-33">
                    {bonus.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}